// extracted by mini-css-extract-plugin
module.exports = {"container":"StrokesPanel_container__HryGb","cellContainer":"StrokesPanel_cellContainer__Z9OQ3","active":"StrokesPanel_active__2H2N0"};